import React from 'react'
import BlocksTable from '../../components/blockstable/BlocksTable'
import {TextField} from '@mui/material'
import { Autocomplete } from '@mui/material'
import {Checkbox} from '@mui/material'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const Blocks = () => {
  return (
    <div className="blocks p-2">
      <div className="flex justify-around gap-2 mb-2">
      <Autocomplete
      multiple
      disableCloseOnSelect
      options={[{"school_type":"DEMO_SCHOOL"},{"school_type":"SSVM"},{"school_type":"SCST_SCHOOL"},{"school_type":"GOVT_SCHOOL"},{"school_type":"AUROBINDO"},{"school_type":"ALC_SCHOOL"},{"school_type":"5T_SCHOOL"},{"school_type":"5T_OAV"},{"school_type":"5T_SCHOOL_P2"}]}
      getOptionLabel={(option) => option.school_type}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 4 }}
            checked={selected}
          />
          {option.school_type}
        </li>
      )}
      style={{ width: 500 }}
      renderInput={params => <TextField {...params} label='Filter by type'/>}
      />


      <Autocomplete
      multiple
      disableCloseOnSelect
      options={[{"district":"NO_DIST"},{"district":"Khordha"},{"district":"Kalahandi"},{"district":"Cuttack"},{"district":"Jagatsinghpur"},{"district":"Jajpur"},{"district":"Balangir"},{"district":"Balasore"},{"district":"Angul"},{"district":"Keonjhar"},{"district":"Puri"},{"district":"Sundergarh"},{"district":"Koraput"},{"district":"Bhadrak"},{"district":"Rayagada"},{"district":"Sambalpur"},{"district":"Bargarh"},{"district":"Jharsuguda"},{"district":"Nayagarh"},{"district":"Subarnapur"},{"district":"Nuapada"},{"district":"Dhenkanal"},{"district":"Deogarh"},{"district":"Boudh"},{"district":"Malkangiri"},{"district":"Mayurbhanj"},{"district":"Gajapati"},{"district":"Ganjam"},{"district":"Kandhamal"},{"district":"Nabarangpur"},{"district":"Kendrapara"},{"district":"Sundargarh"}]} 
      getOptionLabel={(option) => option.district}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.district}
        </li>
      )}
      sx={{flex: 1}}
      renderInput={params => <TextField {...params} label='Filter by District'/>}
      />
      </div>
        {/* <div className="title">Narasinghpur</div> */}
        

          <BlocksTable/>
       

    </div>
  )
}

export default Blocks